/**
 * @generated SignedSource<<6bb63b23332d9b097c2023cb54ba570b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SalesAssociatesScreenQuery$variables = {
  masterdataId: string;
};
export type SalesAssociatesScreenQuery$data = {
  readonly store: {
    readonly id: string;
    readonly salesAssociates: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly fullName: string | null;
      }>;
    };
  } | null;
  readonly viewer: {
    readonly configuration: {
      readonly viewOthersSalesAssociatesPerformance: boolean;
    };
    readonly salesAssociate: {
      readonly id: string;
    } | null;
  };
};
export type SalesAssociatesScreenQuery = {
  variables: SalesAssociatesScreenQuery$variables;
  response: SalesAssociatesScreenQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "masterdataId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "eq",
                "variableName": "masterdataId"
              }
            ],
            "kind": "ObjectValue",
            "name": "masterdataId"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "Store",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 100
          },
          {
            "kind": "Literal",
            "name": "where",
            "value": {
              "active": {
                "eq": true
              }
            }
          }
        ],
        "concreteType": "SalesAssociateConnection",
        "kind": "LinkedField",
        "name": "salesAssociates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesAssociate",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesAssociates(first:100,where:{\"active\":{\"eq\":true}})"
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "VtexUser",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewOthersSalesAssociatesPerformance",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SalesAssociate",
        "kind": "LinkedField",
        "name": "salesAssociate",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesAssociatesScreenQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SalesAssociatesScreenQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b30b50b9849f8aa29624f28b6d019722",
    "id": null,
    "metadata": {},
    "name": "SalesAssociatesScreenQuery",
    "operationKind": "query",
    "text": "query SalesAssociatesScreenQuery(\n  $masterdataId: String!\n) {\n  store(where: {masterdataId: {eq: $masterdataId}}) {\n    id\n    salesAssociates(first: 100, where: {active: {eq: true}}) {\n      nodes {\n        id\n        fullName\n      }\n    }\n  }\n  viewer {\n    configuration {\n      viewOthersSalesAssociatesPerformance\n    }\n    salesAssociate {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "71a5739e3ed97bbb6f238a5cee4c91f4";

export default node;
